import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { ICatalog } from "../shared/models/catalog.model";
import { HistoryData } from "./history";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class CatalogData {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private tracking: TrackingProvider,
  ) { }

  public createOrUpdateCatalog(client: string, catalog: ICatalog) {
    if (catalog.id === "") {
      this.action = "create";
      catalog.id = this.afDb.createPushId();
      catalog.created_at = new Date().getTime();
    } else {
      this.action = "update";
      catalog.update_at = new Date().getTime();
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${client}/Catalogs/${catalog.id}`)
        .update(catalog)
        .then(() => {
          return this.historyData.set(
            `Catalog content`,
            "catalog",
            this.action,
            catalog,
          );
        })
        .then(() => {
          this.tracking.trackEntity(_TRACKING_ENTITIES.CATALOG, catalog.id, client, catalog);
          resolve(catalog);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getCatalogByClientId(client: string): Observable<ICatalog[]> {
    return this.afDb.list<ICatalog>(`Clients/${client}/Catalogs`).valueChanges();
  }

  public getCatalogActiveByClientId(client: string): Observable<ICatalog[]> {
    return this.afDb.list<ICatalog>(
      `Clients/${client}/Catalogs`,
      (ref) => ref.orderByChild("state").equalTo(true),
    ).valueChanges();
  }

  public getCatalogById(
    client: string,
    catalogId: string,
  ): Observable<ICatalog> {
    return this.afDb
      .object<ICatalog>(`Clients/${client}/Catalogs/${catalogId}`)
      .valueChanges();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/catalog.ts